import { createAction } from 'utils/redux'

import { ActiveCampaign } from './types'

export const receiveActiveCampaign = (payload: { data: ActiveCampaign }) => createAction({
  type: 'RECEIVE_ACTIVE_CAMPAIGN',
  payload
})

export const receiveEnrolledCampaign = payload => createAction({
  type: "RECEIVE_ENROLLED_CAMPAIGN",
  payload
})

export const receiveEnrolledInteraction = payload => createAction({
  type: "RECEIVE_ENROLLED_INTERACTION",
  payload
})

export const clearActiveCampaign = () => createAction({
  type: 'CLEAR_ACTIVE_CAMPAIGN'
})


export const receiveCampaignEvalId = payload => createAction({
  type: 'RECEIVE_CAMPAIGN_EVAL_ID',
  payload
})

export const receiveIneligibleCampaigns = payload => createAction({
  type: 'RECEIVE_INELIGIBLE_CAMPAIGNS',
  payload
})

export const receiveUnreadCampaigns = payload => createAction({
  type: 'RECEIVE_UNREAD_CAMPAIGNS',
  payload
})
